export default __webpack_public_path__ + "static/media/rtr-180.3c25c432.svg";